export default __webpack_public_path__ + "static/media/rotate-white.45f3e5d5.svg";